/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

import { getOwner } from '@ember/owner';
import Service from '@ember/service';
import { VaultReportingServiceApi } from '../clients/cloud-vault-reporting/src/apis/VaultReportingServiceApi.ts';

import {
  BASE_PATH,
  Configuration,
} from '../clients/cloud-vault-reporting/src/runtime.ts';

export default class ReportingApiService extends Service {
  /**
   * Attempt to look up the API service from host application if it exists. Using service decorator would error so this allows falling back if it doesn't.
   */
  get api() {
    return getOwner(this)?.lookup('service:api') as
      | { config: (basePath: string) => Configuration }
      | undefined;
  }

  /**
   * Attempt to look up the user context from host application if it exists. Using service decorator would error so this allows falling back if it doesn't.
   */
  get userContext() {
    return getOwner(this)?.lookup('service:user-context') as
      | {
          organization: { id: string };
          project: { id: string };
        }
      | undefined;
  }

  /**
   * Attempt to get the organizationId and projectId from user context in host application.
   * Fall back to default values if not available.
   */

  get organizationId() {
    return this.userContext?.organization?.id || '';
  }

  get projectId() {
    return this.userContext?.project?.id || '';
  }

  /**
   * Attempt to get the API configuration from host application. Fall back to default otherwise.
   */
  get config() {
    if (this.api) {
      return new Configuration(this.api.config(BASE_PATH));
    } else {
      return new Configuration({
        basePath: `${new URL(window.location.href).origin}/api`,
      });
    }
  }

  reporting = new VaultReportingServiceApi(this.config);
}
